import React from "react";
import SearchResultsBackup from "./SearchResultsbackup1";

/**
 * Demo page that renders the backup SearchResults component (SearchResultsbackup1.js).
 * Use URL: /search-results-demo/?job_type=1 (or with other query params like gender=1, etc.)
 */
const SearchResultsDemo = (props) => {
  return (
    <>
      <SearchResultsBackup {...props} />

      {/* JOB DETAILS static page Start  */}
      
              <section className="total-job httge">
                <div className="container">
                  <div className="row py-5 pb-0">
                    <div className="alignflexs pb-3 wsedfw">
                      <div className="flexboxjobinlie">
                        <img src="https://www.andrew.cmu.edu/user/tsethapa/HTML-exercise/examples/imgs/bg5.jpg" className="PVIKAS" alt="PM-VIKAS Scheme" />
                        <p className="maintitle clrwht">UI / UX Designer</p>
                      </div>
                      <div className="text-end p-0">
                        <button className="view-btn">Apply For Job</button>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
      
              <section className="my-5">
               <div className="container">
                  <div className="row">
                     <div className="col-lg-12">
                      <div className="flexboxjobinlie mb-5">
                        <span className="activeclr">HOME</span>
                        <span>GOVERNMENT / PRIVATE / OUT SOURCE</span>
                        <span>UI / UX DESIGNER</span>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="listgridjb">
                          <div className="flexboxjobinlie">
                            <div className="icowdt">
                              <i class="far fa-calendar-alt nwic"></i>
                            </div>
                            <div>
                              <h5 className="title">Date Posted</h5>
                              <p className="mb-0 text">Posted 1 days ago</p>
                            </div>
                          </div>
                          <div className="flexboxjobinlie">
                            <div className="icowdt">
                              <i class="fas fa-map-marker-alt nwic"></i>
                            </div>
                            <div>
                              <h5 className="title">Location</h5>
                              <p className="mb-0 text">Punjab</p>
                            </div>
                          </div>
                          <div className="flexboxjobinlie">
                            <div className="icowdt">
                              <i class="fas fa-briefcase nwic"></i>
                            </div>
                            <div>
                              <h5 className="title">Experience</h5>
                              <p className="mb-0 text">01 - 03 Years</p>
                            </div>
                          </div>
                          <div className="flexboxjobinlie">
                            <div className="icowdt">
                              <i class="fas fa-rupee-sign nwic"></i>
                            </div>
                            <div>
                              <h5 className="title">Salary</h5>
                              <p className="mb-0 text">RS 35000 - 45000</p>
                            </div>
                          </div>
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="mt-5">
                        <h4>Description</h4>
                        <p>
                          It is a long established fact that a reader will be
                          distracted by the readable content of a page when looking
                          at its layout. The point of using Lorem Ipsum is that it
                          has a more-or-less normal distribution of letters, as
                          opposed to using 'Content here, content here', making it
                          look like readable English.It is a long established fact that a reader will be
                          distracted by the readable content of a page when looking
                          at its layout. The point of using Lorem Ipsum is that it
                          has a more-or-less normal distribution of letters, as
                          opposed to using 'Content here, content here', making it
                          look like readable English.
                        </p>
                         <p>
                          It is a long established fact that a reader will be
                          distracted by the readable content of a page when looking
                          at its layout. The point of using Lorem Ipsum is that it
                          has a more-or-less normal distribution of letters, as
                          opposed to using 'Content here, content here', making it
                          look like readable English.It is a long established fact that a reader will be
                          distracted by the readable content of a page when looking
                          at its layout. The point of using Lorem Ipsum is that it
                          has a more-or-less normal distribution of letters, as
                          opposed to using 'Content here, content here', making it
                          look like readable English.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
      
      {/* JOB DETAILS static page End */}

    </>
  );
};

export default SearchResultsDemo;
